import React from 'react'
import styled from 'styled-components'
import Carousel from './../../../../../components/sliders/carousel.component'
import { StyledTopic } from './styled-components'
import { PRIMARY_COLOR, LIGHTGRAY } from '../../../../../styles/colors.style'
import image1 from '../../../../../../assets/images/solicitacao-de-pontos/b1.png'
import image2 from '../../../../../../assets/images/solicitacao-de-pontos/b2.png'
import image3 from '../../../../../../assets/images/solicitacao-de-pontos/b3.png'
import image4 from '../../../../../../assets/images/solicitacao-de-pontos/b4.png'
import image5 from '../../../../../../assets/images/solicitacao-de-pontos/b5.png'
import image6 from '../../../../../../assets/images/solicitacao-de-pontos/b6.png'
import image7 from '../../../../../../assets/images/solicitacao-de-pontos/b7.png'

const banners = [
	{
		src: image1,
		title: 'como localizar os dados da passagem 1',
	},
	{
		src: image2,
		title: 'como localizar os dados da passagem 2',
	},
	{
		src: image3,
		title: 'como localizar os dados da passagem 3',
	},
	{
		src: image4,
		title: 'como localizar os dados da passagem 4',
	},
	{
		src: image5,
		title: 'como localizar os dados da passagem 5',
	},
	{
		src: image6,
		title: 'como localizar os dados da passagem 6',
	},
	{
		src: image7,
		title: 'como localizar os dados da passagem 7',
	},
]

const StyledImg = styled.img`
	max-width: 100%;
`

const StyledImgContainer = styled.div`
	display: inline-block;
	max-width: 100%;
`

const StyledContainer = styled.div`
	text-align: center;
	.carousel {
		margin: 15px 0px;

		li {
			button:before {
				font-size: 16px;
				opacity: unset;
				color: ${LIGHTGRAY};
			}

			&.slick-active button:before {
				opacity: unset;
				color: ${PRIMARY_COLOR};
			}
		}
	}
`

const UserTicketSlider = ({ className, style }) => (
	<StyledContainer style={style} className={className}>
		<StyledTopic className={'blue'}>
			Como localizar os dados da sua passagem
		</StyledTopic>
		<Carousel
			dots={true}
			arrows={false}
			autoplay={false}
			className={'carousel'}>
			{banners.map(({ src, title }, index) => (
				<StyledImgContainer key={index} className={'slide'}>
					<StyledImg src={src} title={title} />
				</StyledImgContainer>
			))}
		</Carousel>
	</StyledContainer>
)

export default UserTicketSlider
